import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { TSDViewGeneralInfoFormValues } from './validateTSDViewGeneralInfoForm';

interface TSDRepresentativeSectionProps {
  form: UseFormReturnType<TSDViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TSDRepresentativeSection: React.FC<TSDRepresentativeSectionProps> = ({ form, disabled }) => {
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Representative
      </Title>

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('representative.identificationNumber')} label="Identification number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('representative.name')} label="Name" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <MultiLangCodes {...form.getInputProps('representative.status')} label="Status" code="CL094" system={codelistSystems} disabled={disabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={5}>
          <TextInput {...form.getInputProps('representative.communication.phoneNumber')} label="Communication phone number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={5}>
          <TextInput {...form.getInputProps('representative.communication.eMailAddress')} label="Communication email address" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
